import { Factory } from 'miragejs';
import faker from 'faker';
import ENV from 'dashboard/config/environment';
import { getRandomInt } from '../utils';

export default Factory.extend({
  firstName() {
    return faker.name.firstName();
  },
  lastName() {
    return faker.name.lastName();
  },
  fullName() {
    return `${this.firstName} ${this.lastName}`;
  },
  email() {
    return faker.internet.exampleEmail(this.firstName, this.lastName);
  },
  picturePath() {
    return ENV.APP.defaultAvatarUrl;
  },
  emailStatus() {
    const opts = ['PENDING', 'VERIFIED', 'UNVERIFIED'];
    return opts[getRandomInt(0, opts.length)];
  },
});
